var map = {
  "./da.json": [
    "72134",
    [
      61675
    ]
  ],
  "./fi.json": [
    "43972",
    [
      74181
    ]
  ],
  "./sv.json": [
    "14712",
    [
      70305
    ]
  ],
  "./ja.json": [
    "29203",
    [
      21913
    ]
  ],
  "./lt.json": [
    "60413",
    [
      54734
    ]
  ],
  "./sl.json": [
    "79106",
    [
      11967
    ]
  ],
  "./fr.json": [
    "46505",
    [
      89394
    ]
  ],
  "./es.json": [
    "91425",
    [
      83706
    ]
  ],
  "./no.json": [
    "11362",
    [
      37983
    ]
  ],
  "./cs.json": [
    "76439",
    [
      10588
    ]
  ],
  "./en.json": [
    "88578",
    [
      47103
    ]
  ],
  "./description/en.json": [
    "51001",
    [
      30114
    ]
  ],
  "./pl.json": [
    "58433",
    [
      24602
    ]
  ],
  "./hu.json": [
    "32230",
    [
      20363
    ]
  ],
  "./nl.json": [
    "13875",
    [
      30096
    ]
  ],
  "./de.json": [
    "69802",
    [
      59415
    ]
  ],
  "./pt.json": [
    "62297",
    [
      20770
    ]
  ],
  "./it.json": [
    "86244",
    [
      12773
    ]
  ],
  "./et.json": [
    "19736",
    [
      21665
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 41168;
module.exports = __rspack_async_context;
